import React, { useState, useEffect } from "react";
import api from "../services/api";

const Categorias = () => {
  const [categorias, setCategorias] = useState([]);
  const [form, setForm] = useState({ nombre: "", descripcion: "" });
  const [editando, setEditando] = useState(false);
  const [categoriaId, setCategoriaId] = useState(null);
  const [cargando, setCargando] = useState(true);

  useEffect(() => {
    obtenerCategorias();
  }, []);

  const obtenerCategorias = async () => {
    try {
      setCargando(true);
      const res = await api.get("/categorias");
      setCategorias(res.data);
    } catch (error) {
      console.error("Error al cargar categorías:", error);
      alert("❌ Error al cargar categorías");
    } finally {
      setCargando(false);
    }
  };

  const guardarCategoria = async () => {
    if (!form.nombre.trim()) {
      alert("⚠️ El nombre es obligatorio");
      return;
    }

    try {
      if (editando) {
        await api.put(`/categorias/${categoriaId}`, form);
        alert("✅ Categoría actualizada correctamente");
      } else {
        await api.post("/categorias", form);
        alert("✅ Categoría agregada correctamente");
      }
      setForm({ nombre: "", descripcion: "" });
      setEditando(false);
      setCategoriaId(null);
      obtenerCategorias();
    } catch (error) {
      console.error("Error al guardar categoría:", error);
      alert("❌ Error al guardar categoría");
    }
  };

  const editarCategoria = (cat) => {
    setForm({ nombre: cat.nombre, descripcion: cat.descripcion || "" });
    setCategoriaId(cat.id);
    setEditando(true);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const cancelarEdicion = () => {
    setForm({ nombre: "", descripcion: "" });
    setEditando(false);
    setCategoriaId(null);
  };

  const eliminarCategoria = async (id) => {
    if (!window.confirm("¿Seguro que deseas eliminar esta categoría?")) return;
    
    try {
      await api.delete(`/categorias/${id}`);
      alert("✅ Categoría eliminada correctamente");
      obtenerCategorias();
    } catch (error) {
      console.error("Error al eliminar categoría:", error);
      alert("❌ Error al eliminar categoría. Puede que tenga materiales asociados.");
    }
  };

  return (
    <div style={styles.container}>
      {/* Header */}
      <div style={styles.header}>
        <div style={styles.headerContent}>
          <h1 style={styles.title}>📂 Gestión de Categorías</h1>
          <p style={styles.subtitle}>Organiza tus materiales por categorías</p>
        </div>
      </div>

      {/* Formulario */}
      <div style={styles.card}>
        <h3 style={styles.cardTitle}>
          {editando ? "✏️ Editar Categoría" : "➕ Nueva Categoría"}
        </h3>
        <div style={styles.formGrid}>
          <div style={styles.formGroup}>
            <label style={styles.label}>Nombre *</label>
            <input
              type="text"
              placeholder="Ej: Eléctrico, Ferretería, Oficina"
              value={form.nombre}
              onChange={(e) => setForm({ ...form, nombre: e.target.value })}
              style={styles.input}
            />
          </div>

          <div style={styles.formGroup}>
            <label style={styles.label}>Descripción</label>
            <input
              type="text"
              placeholder="Descripción opcional"
              value={form.descripcion}
              onChange={(e) => setForm({ ...form, descripcion: e.target.value })}
              style={styles.input}
            />
          </div>
        </div>

        <div style={styles.formActions}>
          <button onClick={guardarCategoria} style={styles.btnSuccess}>
            {editando ? "💾 Actualizar" : "✓ Guardar"}
          </button>
          {editando && (
            <button onClick={cancelarEdicion} style={styles.btnCancel}>
              Cancelar
            </button>
          )}
        </div>
      </div>

      {/* Lista de Categorías */}
      <div style={styles.card}>
        <div style={styles.cardHeader}>
          <h3 style={styles.cardTitle}>📋 Lista de Categorías</h3>
          <span style={styles.badge}>{categorias.length} categorías</span>
        </div>

        {cargando ? (
          <div style={styles.loadingContainer}>
            <p style={styles.loadingText}>Cargando categorías...</p>
          </div>
        ) : categorias.length === 0 ? (
          <div style={styles.emptyState}>
            <span style={styles.emptyIcon}>📂</span>
            <p style={styles.emptyText}>No hay categorías registradas</p>
            <p style={styles.emptySubtext}>Agrega tu primera categoría usando el formulario arriba</p>
          </div>
        ) : (
          <div style={styles.tableWrapper}>
            <table style={styles.table}>
              <thead>
                <tr>
                  <th style={styles.th}>ID</th>
                  <th style={styles.th}>Nombre</th>
                  <th style={styles.th}>Descripción</th>
                  <th style={styles.th}>Acciones</th>
                </tr>
              </thead>
              <tbody>
                {categorias.map((cat) => (
                  <tr 
                    key={cat.id}
                    style={styles.tr}
                    onMouseEnter={(e) => e.currentTarget.style.background = '#f8fafc'}
                    onMouseLeave={(e) => e.currentTarget.style.background = 'white'}
                  >
                    <td style={styles.td}>{cat.id}</td>
                    <td style={styles.tdNombre}>
                      <strong>{cat.nombre}</strong>
                    </td>
                    <td style={styles.td}>{cat.descripcion || "-"}</td>
                    <td style={styles.td}>
                      <div style={styles.actions}>
                        <button
                          onClick={() => editarCategoria(cat)}
                          style={styles.btnEdit}
                          onMouseEnter={(e) => e.currentTarget.style.background = '#f59e0b'}
                          onMouseLeave={(e) => e.currentTarget.style.background = '#fbbf24'}
                        >
                          ✏️ Editar
                        </button>
                        <button
                          onClick={() => eliminarCategoria(cat.id)}
                          style={styles.btnDelete}
                          onMouseEnter={(e) => e.currentTarget.style.background = '#dc2626'}
                          onMouseLeave={(e) => e.currentTarget.style.background = '#ef4444'}
                        >
                          🗑️ Eliminar
                        </button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
};

const styles = {
  container: {
    minHeight: '100vh',
    background: '#f8fafc',
    padding: '20px',
    fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
  },
  header: {
    marginBottom: '25px',
  },
  headerContent: {
    maxWidth: '900px',
    margin: '0 auto',
  },
  title: {
    fontSize: '28px',
    fontWeight: '700',
    color: '#1e293b',
    margin: '0 0 5px 0',
  },
  subtitle: {
    fontSize: '14px',
    color: '#64748b',
    margin: '0',
  },
  card: {
    background: 'white',
    borderRadius: '12px',
    padding: '25px',
    marginBottom: '20px',
    boxShadow: '0 2px 8px rgba(0, 0, 0, 0.06)',
    border: '1px solid #e2e8f0',
    maxWidth: '900px',
    margin: '0 auto 20px auto',
  },
  cardHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: '20px',
  },
  cardTitle: {
    fontSize: '18px',
    fontWeight: '700',
    color: '#1e293b',
    margin: '0 0 20px 0',
  },
  badge: {
    background: '#667eea',
    color: 'white',
    padding: '6px 14px',
    borderRadius: '20px',
    fontSize: '13px',
    fontWeight: '600',
  },
  formGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
    gap: '20px',
    marginBottom: '20px',
  },
  formGroup: {
    display: 'flex',
    flexDirection: 'column',
  },
  label: {
    fontSize: '13px',
    fontWeight: '600',
    color: '#475569',
    marginBottom: '6px',
  },
  input: {
    padding: '10px 12px',
    fontSize: '14px',
    border: '1px solid #cbd5e1',
    borderRadius: '8px',
    outline: 'none',
    transition: 'all 0.2s ease',
  },
  formActions: {
    display: 'flex',
    gap: '12px',
  },
  btnSuccess: {
    padding: '12px 24px',
    background: '#10b981',
    color: 'white',
    border: 'none',
    borderRadius: '8px',
    fontSize: '14px',
    fontWeight: '600',
    cursor: 'pointer',
    transition: 'all 0.2s ease',
  },
  btnCancel: {
    padding: '12px 24px',
    background: '#94a3b8',
    color: 'white',
    border: 'none',
    borderRadius: '8px',
    fontSize: '14px',
    fontWeight: '600',
    cursor: 'pointer',
    transition: 'all 0.2s ease',
  },
  loadingContainer: {
    padding: '40px',
    textAlign: 'center',
  },
  loadingText: {
    color: '#64748b',
    fontSize: '14px',
  },
  emptyState: {
    padding: '60px 20px',
    textAlign: 'center',
  },
  emptyIcon: {
    fontSize: '64px',
    marginBottom: '15px',
    display: 'block',
    opacity: '0.5',
  },
  emptyText: {
    fontSize: '16px',
    fontWeight: '600',
    color: '#475569',
    margin: '0 0 8px 0',
  },
  emptySubtext: {
    fontSize: '14px',
    color: '#94a3b8',
    margin: '0',
  },
  tableWrapper: {
    overflowX: 'auto',
  },
  table: {
    width: '100%',
    borderCollapse: 'collapse',
    fontSize: '14px',
  },
  th: {
    background: '#f8fafc',
    padding: '12px',
    textAlign: 'left',
    fontWeight: '700',
    color: '#475569',
    borderBottom: '2px solid #e2e8f0',
  },
  tr: {
    transition: 'background 0.2s ease',
  },
  td: {
    padding: '12px',
    borderBottom: '1px solid #f1f5f9',
    color: '#1e293b',
  },
  tdNombre: {
    padding: '12px',
    borderBottom: '1px solid #f1f5f9',
    color: '#667eea',
    fontWeight: '600',
  },
  actions: {
    display: 'flex',
    gap: '8px',
  },
  btnEdit: {
    padding: '6px 12px',
    background: '#fbbf24',
    color: 'white',
    border: 'none',
    borderRadius: '6px',
    fontSize: '12px',
    fontWeight: '600',
    cursor: 'pointer',
    transition: 'all 0.2s ease',
  },
  btnDelete: {
    padding: '6px 12px',
    background: '#ef4444',
    color: 'white',
    border: 'none',
    borderRadius: '6px',
    fontSize: '12px',
    fontWeight: '600',
    cursor: 'pointer',
    transition: 'all 0.2s ease',
  },
};

export default Categorias;